/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useContext,
  useRef,
  useEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import { interactionContext } from './interactionContext';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

const MatchingLayout = ({ children }) => {
  // const context = useContext(interactionContext);

  const [layout, setLayout] = useState(1);

  const container = useRef(null);

  useEffect(() => {
    if (!container.current) return;
    const c = container.current;
    const droppableContainer = c.querySelector('.droppable-container');
    // if (!droppableContainer) return;

    const dCWidth = droppableContainer.getBoundingClientRect().width;

    const updateLayout = () => {
      const cWidth = c.getBoundingClientRect().width;
      // const bounds = cWidth >= dCWidth * 2 + dCWidth / 2;
      if (cWidth >= dCWidth * 2 + dCWidth / 2) return setLayout(0);
      if (cWidth < dCWidth * 2 + 20) return setLayout(0);

      setLayout(1);
    };
    updateLayout();

    window.addEventListener('resize', updateLayout);
    return () => window.removeEventListener('resize', updateLayout);
  }, []);

  return (
    <div
      ref={container}
      css={css`
        position: relative;
        ${layout === 1 && 'display: flex;'}
        width: 100%;
      `}
    >
      {children}
    </div>
  );
};

export default MatchingLayout;
